import React from 'react'
import { FaCheck, FaXmark } from "react-icons/fa6"
import { useOffers } from '../../Providers/OffersProvider'

const AddToBasketModeSwitch = () => {
    const { savedOfferId, setSavedOfferId } = useOffers()
    return (
        <div className={`col d-flex justify-content-center`} onClick={() => setSavedOfferId(-1)}>
            <span className='me-4' style={{ fontWeight: 'bold' }}>Tryb zapytania/oferty</span>
            <div className={`navbar-custom-switch ${savedOfferId != -1 ? "active" : ""}`}>
                <div className="navbar-custom-switch-circle">
                    {savedOfferId != -1 ? <FaCheck color='white' /> : <FaXmark color='black' />}
                </div>
            </div>
        </div>
    )
}

export default AddToBasketModeSwitch